import { useQueryParams, useQueryUpdate } from '@shared/hooks'
import { SorterResult } from 'antd/lib/table/interface'

enum OrderType {
  DESCEND = 'descend',
  ASCEND = 'ascend'
}

export const useTableSorter = (): (<T>(
  sorter: SorterResult<T> | SorterResult<T>[]
) => void) => {
  const params = useQueryParams()
  const { updateQuery } = useQueryUpdate()

  const tableSorter = <T>(
    sorter: SorterResult<T> | SorterResult<T>[]
  ): void => {
    const { order, column } = sorter as SorterResult<T>
    updateQuery({
      ...params,
      ordering: order
        ? `${order === OrderType.DESCEND ? '-' : ''}${column && column.key}`
        : (order as null)
    })
  }

  return tableSorter
}
